<div class="page py-4">
  <div class="container py-4">
    <div class="row gy-4">
      <div class="col-12">
        <h1 class="h3 mb-0">Contacto</h1>
      </div>

      <div class="col-12">
        <a [href]="'mailto:' + contactEmail" class="btn btn-primary">
          Enviar correo
        </a>
      </div>

      <div class="col-12">
        <h2 class="h5">¿Tiene una consulta específica? Escríbanos</h2>
      </div>

      <div class="col-12">
        <form [formGroup]="form" (ngSubmit)="submit()">
          <div class="mt-2">
            <label for="email" class="form-label mb-0"
              >CORREO ELECTRÓNICO *</label
            >

            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
            />

            @if (form.get("email")?.invalid && form.get("email")?.touched) {
              <div class="field-feedback">
                Este campo es necesario para contactarle.
              </div>
            }
          </div>

          <div class="mt-2">
            <label for="name" class="form-label mb-0">NOMBRE COMPLETO *</label>

            <input
              type="text"
              class="form-control"
              id="name"
              formControlName="name"
            />

            @if (form.get("name")?.invalid && form.get("name")?.touched) {
              <div class="field-feedback">
                Por favor escriba su nombre y apellido.
              </div>
            }
          </div>

          <div class="mt-2">
            <label for="message" class="form-label mb-0">MENSAJE *</label>

            <textarea
              class="form-control"
              id="message"
              rows="5"
              formControlName="message"
            ></textarea>

            @if (form.get("message")?.invalid && form.get("message")?.touched) {
              <div class="field-feedback">Este campo es obligatorio.</div>
            }
          </div>

          <small class="d-block fw-lighter mt-2">* Campos obligatorios</small>

          @if (alertData()) {
            <div class="py-3 fade-in">
              <app-alert [content]="alertData()"></app-alert>
            </div>
          }

          <div class="mt-2 text-end">
            <button type="submit" class="btn btn-primary btn-contact">Enviar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
